








import { CreditedQuotaStatusEnum, UserCreditData } from '@/pages/home/types';
import { formatCreditAmount } from '@/views_v2/home/components/utils';
import { useMaxQuotaFormatted } from '@/shared/utils/getMaxQuota';
import {
  defineComponent,
  PropType,
  computed,
} from '@vue/composition-api';

/**
 * 额度信息，如：20000、额度已用光
 */
export default defineComponent({
  name: 'MajorAmountInfo',
  props: {
    userCreditData: {
      type: Object as PropType<UserCreditData>,
      required: true,
    },
    creditedQuotaStatus: {
      type: Number as PropType<CreditedQuotaStatusEnum>,
      required: false,
    },
    isMiddleIncomeShow: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const maxQuotaFormatted = useMaxQuotaFormatted();
    /** 额度信息 */
    const majorAmountInfo = computed(() => {
      /** 有额度，但已过期 or 失效 */
      if (props.userCreditData.creditStatus
        && props.creditedQuotaStatus === CreditedQuotaStatusEnum.USE_OUT_AMOUNT) {
        return {
          style: 'text',
          text: '额度已用光',
        };
      }
      /** 有额度 || 有订单，展示提现额度 */
      if (Number(props.userCreditData.creditAmount) > 0
        || (props.userCreditData.creditStatus && props.userCreditData.hasOrder)) {
        return {
          style: 'amount',
          text: formatCreditAmount(props.userCreditData.creditAmount),
        };
      }

      return {
        style: 'amount',
        text: maxQuotaFormatted.value,
      };
    });

    return {
      majorAmountInfo,
    };
  },
});
